import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  redirect,
  Navigate,
} from "react-router-dom";
import HomePage from "./pages/portal/HomePage";
import "./App.css";
import CBPay from "./pages/cbpay/CBPay";
import KBZPay from "./pages/kbzpay/KBZPay";
import UABPay from "./pages/uabpay/UABPay";
import MerchantForm from "./pages/portal/MerchantForm";
import LoginPage from "./pages/portal/LoginPage";
import SideBar from "./pages/portal/_sideBar";
import AuthProvider from "./pages/AuthProvider";
import EnquiryForm from "./pages/portal/EnquiryForm";
import SubMerchant from "./pages/portal/SubMerchant";
import MerchantBank from "./pages/portal/MerchantBank";
import UnauthorizedPage from "./pages/portal/UnauthorizedPage";
import SuccessPage from "./pages/successPage/SuccessPage";
import TransactionManagement from "./pages/portal/TransactionManagement";
import CoreTransactionManagement from "./pages/portal/CoreTransactionManagement";
import AYAPay from "./pages/ayapay/AYAPay";
import OkDollar from "./pages/okdollarpay/OkDollar";
import OkDollarSuccess from "./pages/okdollarpay/OkDollarSuccess";
import OkDollarFail from "./pages/okdollarpay/OkDollarFail";
import EnquiryChart from "./pages/portal/EnquiryChart";
import BankManagement from "./pages/portal/BankManagement";
import VisaMasterCheckoutForm from "./pages/card/VisaMasterCheckoutForm";
import MPUCheckoutForm from "./pages/card/MPUCheckoutForm";
import VisaMasterSuccessPage from "./pages/card/VisaMasterSuccessPage";
import MPUSuccessPage from "./pages/card/MPUSuccessPage";
import MPUFailPage from "./pages/card/MPUFailPage";
import MMQR from "./pages/mmqr/MMQR";

const router = createBrowserRouter([
  {
    id: "root",
    path: "/login",
    Component: LoginPage,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "cbpay/:paymentMethod",
    Component: CBPay,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "kbzpay/:paymentMethod",
    Component: KBZPay,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "mmqr/:paymentMethod",
    Component: MMQR,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "ayapay/:paymentMethod",
    Component: AYAPay,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "okdollar/:paymentMethod",
    Component: OkDollar,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "uabpay/:paymentMethod",
    Component: UABPay,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "okdollar/success",
    Component: OkDollarSuccess,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "okdollar/fail",
    Component: OkDollarFail,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "/successPage",
    Component: SuccessPage,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "/kbzusd/visa_master",
    Component: VisaMasterCheckoutForm,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "/kbzmpu/mpu",
    Component: MPUCheckoutForm,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "card/success",
    Component: VisaMasterSuccessPage,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "card/mpu/success",
    Component: MPUSuccessPage,
    errorElement: <div>Something went wrong!</div>,
  },
  {
    path: "card/mpu/fail",
    Component: MPUFailPage,
    errorElement: <div>Something went wrong!</div>,
  },

  {
    path: "/",
    element: <AuthProvider />,
    errorElement: <div>Something went wrong!</div>,
    children: [
      {
        path: "portalHomePage",
        element: <SideBar />,
      },
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "merchantForm",
        element: (
          <ProtectedRoute>
            <MerchantForm />
          </ProtectedRoute>
        ),
      },
      {
        path: "bankManagement",
        element: (
          <ProtectedRoute>
            <BankManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: "enquiryForm",
        element: <EnquiryForm />,
      },
      {
        path: "enquiryChart",
        element: <EnquiryChart />,
      },
      {
        path: "transactionManagement",
        element: <TransactionManagement />,
      },
      {
        path: "coreTransactionManagement",
        element: <CoreTransactionManagement />,
      },

      {
        path: "/subMerchant/:id",
        element: <SubMerchant />,
      },

      {
        path: "/merchantBank/:id",
        element: <MerchantBank />,
      },
      ,
      {
        path: "/unauthorized",
        element: <UnauthorizedPage />,
      },
    ],
  },
]);

function ProtectedRoute({ children }) {
  const user = JSON.parse(localStorage.getItem("loginUser"));

  if (user.userRole !== "ADMIN") {
    return <Navigate to="/unauthorized" />;
  }

  return children;
}

export default function App() {
  return <RouterProvider router={router} />;
}
